// 动态加载路由
let routers = [];
const modulesFiles = require.context("../pages", true, /-router.js$/);
modulesFiles.keys().forEach(key => {
  routers = routers.concat(modulesFiles(key).default);
});

export default routers;
